import { yup } from '@validations/Yup';
import React from 'react';
//import { Schema, MixedSchema, Ref } from 'yup';

export function useValidation<T extends object = object, C extends object = object>(fields: yup.ObjectSchemaDefinition<Partial<T>, C>, noSortEdges?: [string, string][] | undefined) {
    const ref = React.useRef(fields);

    //const add = React.useCallback((key: keyof T, validation: Schema<T[keyof T], C> | MixedSchema<T[keyof T], C> | Ref) => {
    const add = React.useCallback((key: keyof T, validation: any) => {
        ref.current[key] = validation;
    }, []);

    const remove = React.useCallback((key: keyof T) => {
        delete ref.current[key];
    }, []);

    const createValidationObject = React.useCallback(() => {
        return yup.object().shape(ref.current, noSortEdges);
    }, [noSortEdges]);
    
    const validate = React.useCallback((value: any) => {
        return createValidationObject().validate(value, {
            abortEarly: false
        });
    }, [createValidationObject]);

    const isValid = React.useCallback((value: any, options?: any) => {
        return createValidationObject().isValidSync(value, options);
    }, [createValidationObject]);
    

    return React.useMemo(() => ({
        add, remove, validate, isValid
    }), [add, remove, validate, isValid]);
}